import { openModal } from '@core/components/ModalStack';
import { SelectPaymentIntegrationModelProps } from './SelectPaymentIntegrationModel';

export async function openSelectPaymentIntegrationModel(props: SelectPaymentIntegrationModelProps) {
  const { SelectPaymentIntegrationModel } = await import('./SelectPaymentIntegrationModel');

  openModal(SelectPaymentIntegrationModel, props);
}
